import request from '@/utils/request'

let getStatusStatistics=(data)=>request.post('/api/statusStatisticsMain/find',data)
let exportStatusStatistics=(data)=>request.post('/api/statusStatisticsMain/export',data)
let getImeiSingleStatusStatistics=(data)=>request.post('/api/statusStatisticsImei/find',data)
let getImeiListStatusStatistics=(data)=>request.post('/api/statusStatisticsImei/searchByImportImei',data)
let getAllProductList=(data)=>request.post('/api/product/listProductName',data)

export default {
  getStatusStatistics,
  exportStatusStatistics,
  getImeiSingleStatusStatistics,
  getImeiListStatusStatistics,
  getAllProductList
}